import { Box, styled } from '@mui/material';

export const NetworkNavigationPanelContainer = styled(Box)(() => ({
  flexShrink: '0',
  flexGrow: 1,
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
}));

export const NetworkNavigationSearchContainer = styled(Box)(() => ({
  minWidth: '200px',
  maxWidth: '200px',
}));
